import { liveSocketGridColumnDefs } from '@features/user-account/utils';
import { Box } from '@mui/material';
import { LiveWebsocket } from '@protos/v2/serverinfo';
import { filterColumnChooserFromMainMenu } from '@utils/contextMenuUtils';
import { CellClickedEvent, ColDef } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { useMemo } from 'react';

type LiveWebsocketGridProps = {
  data: LiveWebsocket[];
  onUserClicked?: (params: CellClickedEvent) => void;
  height?: string;
};

export const LiveWebsocketGrid = ({ data, height, onUserClicked }: LiveWebsocketGridProps) => {
  const columnDefs = useMemo(
    () => [
      ...(onUserClicked
        ? [
            {
              headerName: 'User ID',
              field: 'user_id',
              onCellClicked: onUserClicked,
              cellStyle: {
                cursor: 'pointer',
              },
            },
          ]
        : []),
      ...liveSocketGridColumnDefs,
    ],
    []
  );
  return (
    <Box height={height}>
      <AgGridReact
        containerStyle={{
          height: '100%',
          width: '100%',
          marginTop: '15px',
        }}
        className="ag-theme-balham-dark custom-grid"
        columnDefs={columnDefs as ColDef<LiveWebsocket>[]}
        rowData={data}
        autoSizeStrategy={{
          type: 'fitGridWidth',
        }}
        getMainMenuItems={filterColumnChooserFromMainMenu}
        defaultColDef={{
          suppressHeaderMenuButton: true,
        }}
      />
    </Box>
  );
};
